import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { SidebarIcon } from './SidebarIcon';
import './AdviceNavigation.css';

const mobile = () => Boolean(window.matchMedia?.('(max-width: 760px)').matches);
const links = [
  { to: '/instructions', label: 'Chirurgische Eingriffe' },
  { to: '/instructions/homebleaching', label: 'Homebleaching' },
];

export function AdviceNavigation() {
  const { pathname } = useLocation();
  const active = links.some(link => link.to === pathname);
  const [open, setOpen] = useState(() => active && !mobile());
  const ref = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);

  useEffect(() => { setOpen(active && !mobile()); }, [pathname, active]);
  useEffect(() => {
    const pointer = (event: PointerEvent) => {
      if (ref.current) ref.current.dataset.input = 'pointer';
      if (mobile() && !ref.current?.contains(event.target as Node)) setOpen(false);
    };
    const keyboard = (event: KeyboardEvent) => {
      if (ref.current) ref.current.dataset.input = 'keyboard';
      if (event.key === 'Escape' && ref.current?.contains(event.target as Node)) {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener('pointerdown', pointer, true);
    document.addEventListener('keydown', keyboard, true);
    return () => {
      document.removeEventListener('pointerdown', pointer, true);
      document.removeEventListener('keydown', keyboard, true);
    };
  }, []);

  return (
    <div ref={ref} className="advice-navigation">
      <button ref={toggleRef} type="button" className="advice-navigation__toggle" data-active={active}
        aria-expanded={open} aria-controls="patient-advice-navigation" onClick={() => setOpen(value => !value)}>
        <SidebarIcon name="document" className="advice-navigation__icon" />
        <span>Ratgeber und Tipps</span>
      </button>
      {open && <div id="patient-advice-navigation" className="advice-navigation__submenu">
        {links.map(link => <NavLink key={link.to} to={link.to} end onClick={() => {
          localStorage.setItem('previousPage', ' ');
          if (mobile()) { setOpen(false); window.scrollTo(0, 0); }
        }}>{link.label}</NavLink>)}
      </div>}
    </div>
  );
}
